import React from 'react';

const DriveDetailsPage = () => {
  return (
    <div className="p-4">
      <h2>DriveDetailsPage</h2>
      <p>Mock data and UI will be implemented here.</p>
    </div>
  );
};

export default DriveDetailsPage;
